import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { AppStateContext } from "../AppState";
import { CheckLogin } from "../shared/components/CheckLogin";
import { LoadingScreen } from "../shared/components/LoadingScreen";
import { platformService } from "../shared/services/platform.service";

export const GetAttachmentFileFlow: React.FC = () => {
    const { ticketId } = useParams<any>();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const commentId = query.get('commentId');

    const api = new platformService();
    const [isDownloaded, setIsDownloaded,] = useState<boolean>(false);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);

    const loadPage = async () => {
        if (!isDownloaded) {
            await api.getTicketAttachments(ticketId, commentId);
            setIsDownloaded(true);
            setIsLoading(false);
        }
    };

    return (
        <AppStateContext.Consumer>
            {(state) => {
                return (
                    <CheckLogin onSignedIn={loadPage}>
                        <Helmet>
                            <title>{t('ai-configuration.downloadfile')}</title>
                        </Helmet>
                        <div className="hidden md:block">
                        {isLoading ? 
                          <LoadingScreen message={`${t('ai-configuration.retrieving')}`} /> : 
                          <div>{t('common.download-complete')}</div>
                        }
                        </div>
                    </CheckLogin>
                )
            }}
        </AppStateContext.Consumer>
    );
}